import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { api } from '../api/api';
import { toast } from 'sonner';

const ResumeCart = ({ userId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resumeCheckout = async () => {
      if (!userId) {
        setError('No user session found');
        setLoading(false);
        return;
      }

      try {
        // Call resume checkout API
        const response = await api.resumeCheckout(userId);
        
        if (response.url) {
          // Redirect to Stripe checkout
          toast.success('Resuming your checkout...');
          window.location.href = response.url;
        } else {
          throw new Error('No checkout URL received');
        }
      } catch (err) {
        console.error('Resume checkout error:', err);
        setError(err.response?.data?.detail || 'Failed to resume checkout');
        setLoading(false);
        toast.error('Could not resume checkout. Please try again.');
      }
    };

    resumeCheckout();
  }, [userId]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold mb-2" style={{color: '#3D2817'}}>
              Resuming Your Checkout...
            </h2>
            <p className="text-gray-600">Please wait while we prepare your checkout session</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="max-w-md mx-auto text-center p-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-2" style={{color: '#3D2817'}}>
              Unable to Resume Checkout
            </h2>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => navigate('/cart')}
              className="px-6 py-3 rounded-lg font-semibold text-white"
              style={{backgroundColor: '#2C7A9F'}}
            >
              Go to Cart
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return null;
};

export default ResumeCart;
